/* eslint-disable */
// Auto-generated from src/types/dashConfig.d.ts – 2025-05-21
export const userSchema = {
  $schema: "http://json-schema.org/draft-07/schema#",
  title: "DashCardsGraphicsArray",
  type: "array",
  items: {
    type: "object",
    properties: {
      id: { type: "string" },
      title: { type: "string" },
      subtitle: { type: "string" },
      description: { type: "string" },
      split: { type: "boolean" },
      noPadding: { type: "boolean" },
      background: { type: "boolean" },
      height: { type: ["number", "string", "object"] },
      orientation: { type: ["object", "string"] },
      separator: { enum: ["divider", "dividerDashed"] },
      divisionEqual: { type: "boolean" },
      size: { type: "object" },
      graphics: { type: "array" },
    },
    additionalProperties: false,
  },
} as const;
